import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { buildHeaders, XmStore } from 'core/services';

import { PastDue, RetryPaymentData, RetryPaymentResult } from 'store/past-due/models';

import { StoreAction } from 'store/actions';
import { ApiChannel } from 'core/constants';

@Injectable()
export class PastDueApi {
    public static saveRetryPaymentData(_xmStore: XmStore, _http: HttpClient, payload: object): Observable<RetryPaymentData> {
        return of(RetryPaymentData.create<RetryPaymentData>(payload));
    }

    public static getRetryPaymentData(_xmStore: XmStore, _http: HttpClient, paymentDetails: RetryPaymentData): Observable<RetryPaymentData> {
        return of(paymentDetails);
    }

    public static getPastDue(_xmStore: XmStore, http: HttpClient): Observable<PastDue> {
        return http.get('/account/pastduepayment', {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: PastDue) => PastDue.create<PastDue>(response))
        );
    }

    public static retryPayment(_xmStore: XmStore, http: HttpClient, newPaymentInstrument: NewPaymentInstrument | ExistingCardWithAmount): Observable<RetryPaymentResult> {
        return http.post('/account/pastduepayment', newPaymentInstrument, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: RetryPaymentResult) => RetryPaymentResult.create<RetryPaymentResult>(response))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_PAST_DUE] = PastDueApi.getPastDue;
ModelBase.persistMapping[StoreAction.POST_RETRY_PAYMENT] = PastDueApi.retryPayment;
ModelBase.persistMapping[StoreAction.SAVE_RETRY_PAYMENT_DATA] = PastDueApi.saveRetryPaymentData;
ModelBase.fetchMapping[StoreAction.GET_RETRY_PAYMENT_DATA] = PastDueApi.getRetryPaymentData;
